import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logoutStore } from '../modules/is_logged_in';
import { navigate } from '../modules/high_level_actions';
import { openLoginModal } from '../modules/active_modal';
import IconCustomerState from './IconCustomerState.jsx';
import IconCreditState   from './IconCreditState.jsx';
import IconWishlistState from './IconWishlistState.jsx';
import IconCartState     from './IconCartState.jsx';
import Offer             from './Offer.jsx';


class TopNav extends Component {



  constructor(props) {
    super(props);
    this.state = {
      isCollapsedDesktop: false,
      isExpandedMobile: false
    };
  }

  render() {
    let {dispatch, store_bundle_pricing, tla}          = this.props;
    let oLoggedInMenu       = [];
    let oMobileLeftMenu     = [];
    let oLogo               = [];
    const aStoreType        = this.props.storeType;
    const aStoreTla         = this.props.tla;
    const aStatus           = this.props.customer.status;
    const sFulfillmentType  = this.props.customer.fulfillment_type || '';

    //check to see if all conditons are met to see logged/ member in nav

    if( aStatus === "Active" && this.props.isLoggedIn && (
      (aStoreType === "Neglite" && (sFulfillmentType === 'Positive' || sFulfillmentType === 'Negative' )) ||
      (aStoreType === "Negative Option" && (sFulfillmentType === "Positive" || sFulfillmentType === "Negative" ))
      )){
        oLoggedInMenu = (
          <ul>
            <li className="account">
              <IconCustomerState />
            </li>
            { this.props.storeType === "Neglite" ?
              (<li className="credit">
                <IconCreditState />
              </li>) : (<li />)
            }
            <li className="wishlist">
              <IconWishlistState />
            </li>
            <li className="box">
              <IconCartState />
            </li>
          </ul>
        );
        oMobileLeftMenu = (
          <ul className="for-mobile">
            { this.props.storeType === "Neglite" ?
              (<li className="credit">
                <IconCreditState />
              </li>) : (<div />)
            }
            <li className="wishlist">
              <IconWishlistState />
            </li>
          </ul>
        );
    } else{
      oLoggedInMenu = (
        <button className="btn-primary" onClick={() => dispatch( logoutStore() )}>Log Out</button>
      );
    }

    let oLoggedOutMenu = (
      <button className="btn-header" onClick={() => dispatch( openLoginModal() )}>
        Log In
      </button>
    );

    if (this.props.customer.status === 'Pending' || this.props.customer.status === "Upgrading"){
      oLoggedOutMenu = (
        <button className="btn-primary" onClick={() => dispatch( logoutStore() )}>Log Out</button>
      );
    }

    return (
        <div className= "content-max-width" >
          <div className="header-menu left">
            { this.props.isLoggedIn ? oMobileLeftMenu : '' }
            <Offer />
          </div>
          <div className="logo">
            <a href="/" onClick={(evt) => this.props.dispatch( navigate(evt))} className="reg-logo"><img src={'/images/' + tla.toLowerCase() + '/logo.svg'} /></a>
            <a href="/" onClick={(evt) => this.props.dispatch( navigate(evt))} className="mobile-logo"><img src={'/images/' + tla.toLowerCase() + '/icon-logo.svg'} /></a>
          </div>
          <div className="header-menu right">
              { this.props.isLoggedIn ? oLoggedInMenu : oLoggedOutMenu }
          </div>
        </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'tla': state.store.tla,
      'store_bundle_pricing': state.store.bundle_pricing,
      'customer': state.customer,
      'isLoggedIn': state.isLoggedIn,
      'storeType': state.store.type
    };
}

export default connect(mapStateToProps)(TopNav);



// WEBPACK FOOTER //
// ./src/components/TopNav.jsx